import React, { useEffect, useRef } from 'react';
import Button from '@cloudhub-ux/core/Button';
import Block from '@cloudhub-ux/core/Block';
import axios from 'axios';
import { colors } from 'theme';

const PDFViewer = ({ url, filename }) => {
  const [hasValidContentType, sethasvalidContentType] = React.useState(false);
  // const iframeRef = useRef(null);

  const getPdf = React.useCallback(async () => {
    try {
      const response = await axios.head(url);
      const contentType = response.headers['content-type'];
      if (contentType === 'application/pdf') {
        sethasvalidContentType(true);
        // console.log({ contentType });
        return;
      }
    } catch (error) {
      console.log(error);
    }
  }, [url]);

  const downloadPdf = async () => {
    try {
      axios({
        method: 'GET',
        url,
        responseType: 'blob',
      })
        .then((response) => {
          // Create a URL for the blob
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);

          // Set the iframe src to the blob URL
          // if (iframeRef.current) {
          //   iframeRef.current.src = blobUrl;
          // }
          const tempLink = document.createElement('a');
          tempLink.href = blobUrl;
          tempLink.setAttribute('download', filename || 'entry_file.pdf');
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('Error fetching PDF:', error);
        });
    } catch (error) {}
  };

  // useEffect(() => {
  //   // Fetch the PDF content as a blob
  //   axios({
  //     method: 'GET',
  //     url,
  //     responseType: 'blob',
  //   })
  //     .then((response) => {
  //       // Create a URL for the blob
  //       const blob = new Blob([response.data], { type: 'application/pdf' });
  //       const blobUrl = URL.createObjectURL(blob);

  //       // Set the iframe src to the blob URL
  //       if (iframeRef.current) {
  //         iframeRef.current.src = blobUrl;
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching PDF:', error);
  //     });
  // }, [url]);
  useEffect(() => {
    getPdf();
  }, [getPdf]);

  if (hasValidContentType) {
    return (
      <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          title="PDF Viewer"
          src={url}
          style={{ width: '100%', height: '100%', border: 'none' }}
          // sandbox="allow-scripts"
        />
      </div>
    );
  }

  return (
    <Block row center padding={15}>
      {/* <a
        rel="noreferrer noopener"
        target="_blank"
        href={url}
        download={filename || 'my-document.pdf'}
      > */}
      <Button
        style={{
          padding: 15,
          backgroundColor: colors.primary,
          color: 'white',
          fontWeight: 'bold',
          maxWidth: 'fit-content',
        }}
        onClick={downloadPdf}
      >
        Download PDF
      </Button>
      {/* </a> */}
    </Block>
    // <div style={{ width: '100%', height: '100vh' }}>
    //   <iframe
    //     ref={iframeRef}
    //     title="PDF Viewer"
    //     style={{ width: '100%', height: '100%', border: 'none' }}
    //     sandbox="allow-scripts allow-same-origin"
    //   />
    // </div>
  );
};

export default PDFViewer;
